import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconApplicationStatusRejectedCircle.tsx
const IconApplicationStatusRejectedCircle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 20 20",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		d: "M10 18.333a8.333 8.333 0 1 1 0-16.666 8.333 8.333 0 0 1 0 16.666m0-9.511L7.642 6.464l-1.18 1.18L8.822 10l-2.357 2.357 1.179 1.179 2.356-2.358 2.357 2.358 1.18-1.18L11.177 10l2.357-2.357-1.179-1.179z"
	})]
});
var IconApplicationStatusRejectedCircle_default = forwardRef(IconApplicationStatusRejectedCircle);
//#endregion
export { IconApplicationStatusRejectedCircle_default as default };
